export function getScrollbarWidth() {
    var outer = document.createElement( 'div' )
    outer.style.visibility = 'hidden'
    outer.style.width = '100px'
    outer.style.msOverflowStyle = 'scrollbar'

    document.body.appendChild( outer )

    var widthNoScroll = outer.offsetWidth

    // Force scrollbars:
    outer.style.overflow = 'scroll'

    // Add innerdiv:
    var inner = document.createElement( 'div' )
    inner.style.width = '100%'
    outer.appendChild( inner )

    var widthWithScroll = inner.offsetWidth

    // Remove divs:
    outer.parentNode.removeChild( outer )

    return widthNoScroll - widthWithScroll
}



// WEBPACK FOOTER //
// ./utilities/scrollbar.jsx